import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Lightbulb, Wand2, BookOpen } from 'lucide-react';
export function BonusSection() {
  return <section className="py-24 px-5 relative overflow-hidden" data-id="element-9">
      <div className="absolute right-0 top-0 w-1/2 h-full bg-[#7c3aed]/5 blur-[150px] pointer-events-none" data-id="element-10" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#7c3aed]/20 mb-6" data-id="element-13">
            <Gift className="w-8 h-8 text-[#7c3aed]" data-id="element-14" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-15">
            Si te unes hoy, incluyo esto{' '}
            <span className="text-[#7c3aed]" data-id="element-16">GRATIS</span>:
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-17">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative p-[1px] rounded-2xl bg-gradient-to-b from-[#7c3aed]/50 to-transparent" data-id="element-18">
            <div className="bg-[#111118] h-full p-8 rounded-2xl flex flex-col" data-id="element-19">
              <div className="flex items-center gap-3 mb-4" data-id="element-20">
                <span className="bg-[#7c3aed] text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-21">
                  Bonus 1
                </span>
                <span className="text-gray-500 line-through text-sm" data-id="element-22">
                  Valor: $47
                </span>
              </div>
              <Lightbulb className="w-8 h-8 text-[#7c3aed] mb-4" data-id="element-23" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-24">
                Master-List de Iluminación Cinematográfica
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-25">
                Los prompts exactos para replicar la iluminación de estudios
                profesionales, luz de neón, golden hour y claroscuro dramático.
              </p>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative p-[1px] rounded-2xl bg-gradient-to-b from-[#7c3aed]/50 to-transparent" data-id="element-26">
            <div className="bg-[#111118] h-full p-8 rounded-2xl flex flex-col" data-id="element-27">
              <div className="flex items-center gap-3 mb-4" data-id="element-28">
                <span className="bg-[#7c3aed] text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-29">
                  Bonus 2
                </span>
                <span className="text-gray-500 line-through text-sm" data-id="element-30">
                  Valor: $39
                </span>
              </div>
              <Wand2 className="w-8 h-8 text-[#7c3aed] mb-4" data-id="element-31" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-32">
                Guía de "In-Painting" Avanzado
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-33">
                Cómo corregir manos deformes, ojos asimétricos o detalles del
                fondo en segundos sin tener que generar la imagen desde cero.
              </p>
            </div>
          </motion.div>

          {/* Bonus 3 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="relative p-[1px] rounded-2xl bg-gradient-to-b from-[#7c3aed]/50 to-transparent sm:col-span-2 lg:col-span-1" data-id="element-34">
            <div className="bg-[#111118] h-full p-8 rounded-2xl flex flex-col" data-id="element-35">
              <div className="flex items-center gap-3 mb-4" data-id="element-36">
                <span className="bg-[#7c3aed] text-white text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-37">
                  Bonus 3
                </span>
                <span className="text-gray-500 line-through text-sm" data-id="element-38">
                  Valor: $57
                </span>
              </div>
              <BookOpen className="w-8 h-8 text-[#7c3aed] mb-4" data-id="element-39" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-40">Método Base</h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-41">
                El framework fundamental para construir tu primer clon IA desde
                cero, con los parámetros exactos de configuración y el flujo de
                trabajo paso a paso.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}